import React from "react";
import { gql } from "@apollo/client";

import { Typography } from "@mui/material";
import { KeyboardTab as StateChangeIcon } from "mdi-material-ui";

const Icon = () => <StateChangeIcon />;

const Title = ({ orderEvent }) => (
  <Typography variant="h4" color="primary" component="div">
    {orderEvent.oldState.label}
    {" ⭢ "}
    {orderEvent.newState.label}
  </Typography>
);

const fragments = {
  orderEvent: gql`
    fragment Orders_OrderEvent_StateChangeEvent_OrderEvent on OrderEvent {
      id

      ... on OrderEvent_StateChange {
        oldState {
          id
          label
        }
        newState {
          id
          label
        }
      }
    }
  `,
};

const Event = { Icon, Title, fragments };

export default Event;
